<template>
  <div>
    <v-autocomplete
      v-model="lazyValue"
      v-validate="{ required: !!lkPublicationId }"
      dense
      outlined
      item-text="name"
      item-value="id"
      :name="name"
      :error="$errors.has(name)"
      :error-messages="$errors.first(name)"
      :data-vv-as="dataVvAs || label"
      :items="itemsFiltered"
      :label="label"
      :loading="isLoading"
      :disabled="!lkPublicationId"
      hide-details="auto"
      @focus="onFocus"
    >
      <template v-if="label" #label>
        <span>{{ label }}*</span>
      </template>
      <template
        #append-item
      >
        <v-btn
          v-if="isLoadMoreAvailable"
          :loading="isLoading"
          depressed
          small
          block
          @click="onLoadMoreClick"
          v-text="'Загрузить еще'"
        />
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import uniqueId from 'lodash/uniqueId'
import { LkEventPublicationsStoragesApi } from '@/api/resources'

export default {
  inject: ['$validator'],
  props: {
    value: Number,
    label: String,
    dataVvAs: String,
    lkPublicationId: Number,
    name: {
      type: String,
      default: () => uniqueId('storage-autocomplete-'),
    },
    exclude: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    items: [],
    meta: null,
    page: 1,
    isLoading: false,
  }),

  computed: {
    lazyValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    isLoadMoreAvailable() {
      if (this.isLoading) {
        return false
      }
      const { meta } = this
      return meta?.count && this.items.length !== meta.count
    },
    itemsFiltered() {
      if (!this.exclude.length) {
        return this.items
      }
      return this.items.filter((el) => !this.exclude.includes(el.id))
    },
  },
  watch: {
    lkPublicationId: {
      handler() {
        this.resetState()
      },
      immediate: true,
    },
  },
  methods: {
    onFocus() {
      if (!this.lkPublicationId || this.isLoading) {
        return
      }

      if (!this.items.length && !this.meta) {
        this.fetchItems()
      }
    },
    async fetchItems() {
      if (!this.lkPublicationId || this.isLoading) {
        return
      }

      this.isLoading = true
      try {
        const api = new LkEventPublicationsStoragesApi()
        const response = await api.getPublications(this.lkPublicationId, { page: this.page, perPage: 50 })
        if (Array.isArray(response.data)) {
          this.items.push(...response.data)
        }
        this.meta = response.meta ?? null
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isLoading = false
      }
    },
    onLoadMoreClick() {
      this.page += 1
      this.fetchItems()
    },
    resetState() {
      this.items = []
      this.meta = null
      this.lazyValue = null
      this.page = 1
    },
  },
}
</script>
